import React from 'react'
import AnimatedContent from './Animations/AnimatedContent'
import BlurText from './Animations/BlurText'

export default function DoraAgaint() {
    return (
        <div className='lg:w-[80%] w-[90%] mx-auto md:mt-[5vw] mt-10 '>
            <AnimatedContent
                distance={150}
                direction="vertical"
                reverse={false}
                config={{ tension: 80, friction: 20 }}
                initialOpacity={0.2}
                animateOpacity
                scale={1}
                threshold={0.2}
            >
                <div className='DoraAgaint tok before:!z-50 flex items-center flex-col text-center md:gap-3 gap-5 justify-center lg:h-[30vw] md:h-[50vw] h-[130vw] rounded-2xl lg:px-20 px-5 py-10'>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <BlurText
                            text="Why Vocal AI?"
                            delay={150}
                            animateBy="words"
                            direction="top"
                            className="md:text-4xl text-2xl font-medium md:text-start text-center"
                        />

                    </AnimatedContent>
                    <AnimatedContent
                        distance={150}
                        direction="horizontal"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <p className='md:text-base text-sm font-light' >
                            In the fast-paced crypto world, Vocal AI gives traders the edge with voice-powered simplicity. Say goodbye to clunky dashboards and missed opportunities—your voice is now your strongest tool.
                            With NLP and Ethereum-based algorithms, Vocal AI delivers an efficient, user-friendly experience for traders of all levels</p>

                    </AnimatedContent>

                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <button className='md:px-8 px-6 md:py-3 py-2 md:text-base text-sm btn2 transition-all duration-150 flex items-center gap-3 rounded-3xl font-medium '>
                            Join Community
                        </button>
                    </AnimatedContent>


                </div>
            </AnimatedContent>

        </div>
    )
}
